import * as player from '../player.js';
import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import * as triangle from '../triangle.js';

export {
    init,
}

let hydroSound;

const POIs = [
    {
        name: 'lake',
        position: { x: -10, y: -22, z: 0 },
        image: 'lake',
        sound: {
            name: 'swamp', // TODO: other sound for lake ?
            gain: 0,
        },
        symbolic: false,
        collision: {
            radius: 4,
        },
        async onEnter() {
            audio.buffers.play('lakePlouf');
            hydroSound = await audio.buffers.play('hydro', {
                loop: true,
                gain: 0,
                when: 0.6,
            });
            player.config.maxVelocity = 1;

            triangle.drop('stonehenge-triangle-1', this.position, {
                collisionRadius: 0.5,
                delay: 5,
                offset: { x: 1.5, y: -2 }
            });
        },
        onLeave() {
            audio.buffers.play('lakeOut', {
                gain: 0,
            });
            hydroSound.stop();
            player.config.maxVelocity = 2.5;
        },
        onStart() {
            audio.panner.play(this);
        },
    },
];

const sounds = [
    { name: 'hydro', url: new URL('../../sound/hydro.wav', import.meta.url) },
    { name: 'lakePlouf', url: new URL('../../sound/MaraisPlouf.wav', import.meta.url) },
    { name: 'lakeOut', url: new URL('../../sound/MaraisOut.wav', import.meta.url) },
];

const images = [
    { name:'lake', url: new URL('../../images/lake.png', import.meta.url), ppm: 25 },
];

function init() {
    scene.addPOIs(POIs);
    loader.addImages(images);
    loader.addSounds(sounds);
};
